<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/"><i class="icon-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Reset lozinke</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <div class="page-header">
      <div class="container">
        <h1>Reset lozinke</h1>
      </div>
      <!-- End .container -->
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <section>
            <div class="panel card-sign">
              <div class="card-title-sign mt-3 text-end">
                <h2 class="title text-uppercase font-weight-bold">
                  <i class="bx bx-user-circle me-1 text-6 position-relative top-5"></i>
                  Oporavak lozinke
                </h2>
              </div>
              <div>
                <form @submit.prevent.stop="resetPassword">
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Lozinka"
                    v-model="password"
                  />
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Potvrda lozinke"
                    v-model="confirmPassword"
                  />
                  <div class="form-footer">
                    <button type="submit" class="btn btn-primary">
                      Resetuj
                    </button>
                    <router-link class="forget-pass" :to="{ name: 'Login' }">
                      Login
                    </router-link>
                  </div>
                  <!-- End .form-footer -->
                </form>
              </div>
            </div>

            <p class="text-center text-muted mt-3 mb-3">
              Eurosan B2B. &copy; {{ currentYear }}. Sva prava pridržana
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    resetPassword() {
      if (!this.password || !this.confirmPassword || this.password !== this.confirmPassword) {
        this.$toast.error('Unešeni podaci nisu validni!');
        return;
      }
      const { userEmail: email, token } = this.$route.query;

      const payload = {
        email,
        password: this.password,
        confirmPassword: this.confirmPassword,
        // Replaces spaces with + character
        token: decodeURIComponent(token).replace(/ /g, '+'),
      };

      api.resetPassword(payload).then(() => {
        this.$router.push({ name: 'PasswordResetSuccess' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
};
</script>
